import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { ClientItemId } from 'owa-client-ids';
import { ComposeViewState, lazyReplyToMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { ActionSource } from 'owa-analytics-actions';
import { InstrumentationContext } from 'owa-mail-store';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import allowResponseForSmimeConversation from 'owa-smime/lib/utils/allowResponseForSmimeConversation';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';

export default action('replyToConversation')(async function replyToConversation(
    conversationId: ClientItemId,
    isReplyAll: boolean,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    useFullCompose?: boolean,
    suppressServerMarkReadOnReplyOrForward?: boolean,
    initialComposeLogTraceId?: string,
    onComposeViewStateCreated?: (newComposeViewState: ComposeViewState) => void
) {
    const referenceItemId = await getLatestNonDraftItemIdFromConversation(conversationId);
    if (referenceItemId && referenceItemId.Id) {
        const restrictionToConfirm = <IRMRestrictions>{
            ReplyAllAllowed: isReplyAll,
            ReplyAllowed: !isReplyAll,
        };
        const itemActionString = isReplyAll ? strings.itemHeaderReplyAll : strings.itemHeaderReply;

        if (
            confirmItemActionAllowed(
                referenceItemId.Id,
                restrictionToConfirm,
                format(strings.irm_actionNotAllowedOnThisConversation, itemActionString)
            ) &&
            allowResponseForSmimeConversation(referenceItemId.Id, itemActionString)
        ) {
            const replyToMessage = lazyReplyToMessage.importAndExecute({
                referenceItemId: referenceItemId,
                isReplyAll: isReplyAll,
                useFullCompose: useFullCompose,
                actionSource: actionSource,
                instrumentationContexts: instrumentationContexts,
                conversationId: useFullCompose ? null : conversationId.Id,
                initialComposeLogTraceId: initialComposeLogTraceId,
                onComposeViewStateCreated: onComposeViewStateCreated,
                suppressServerMarkReadOnReplyOrForward: suppressServerMarkReadOnReplyOrForward,
            });

            mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
            return replyToMessage;
        }
    }
});
